import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=0aea8b0d&scoped=true&"
import script from "./pricing.vue?vue&type=script&lang=js&"
export * from "./pricing.vue?vue&type=script&lang=js&"
import style0 from "./pricing.vue?vue&type=style&index=0&id=0aea8b0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea8b0d",
  null
  
)

export default component.exports